<div [matTooltip]="'Shape'" [matTooltipPosition]="'before'">
  <button
    mat-icon-button
    class="text-[18px]"
    [class.active]="active"
    [y42Permission]="state.isCanvasEditable"
    [permissionTooltip]="'You do not have permission to edit the asset'"
    [intercomTarget]="'toolbar-insert-shape'"
    (click)="shapesMenuTrigger.openMenu()"
  >
    <fa-icon [icon]="state.shape.icon" [transform]="state.shape.transform" [rotate]="state.shape.rotate"></fa-icon>
    <div class="menu-trigger" #shapesMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="shapesMenu"></div>
  </button>
</div>

<mat-menu #shapesMenu="matMenu" [overlapTrigger]="false" [backdropClass]="toolbarBackdropClass">
  <div class="shapes-menu">
    <button
      mat-icon-button
      *ngFor="let shape of firstShapes; trackBy: trackByValue"
      intercomTarget="toolbar-insert-shape-{{ shape.name }}"
      (click)="selectTool.next(shape)"
    >
      <fa-icon [icon]="shape.icon" [transform]="shape.transform" [rotate]="shape.rotate" class="text-[16px]"></fa-icon>
    </button>
    <ng-container *ngIf="showAllShapes">
      <button
        mat-icon-button
        *ngFor="let shape of restShapes; trackBy: trackByValue"
        intercomTarget="toolbar-insert-shape-{{ shape.name }}"
        (click)="selectTool.next(shape)"
      >
        <fa-icon
          [icon]="shape.icon"
          [transform]="shape.transform"
          [rotate]="shape.rotate"
          class="text-[16px]"
        ></fa-icon>
      </button>
    </ng-container>
  </div>
  <div class="shapes-menu-show-all">
    <button mat-button (click)="$event.stopPropagation(); showAllShapes = !showAllShapes">
      {{ showAllShapes ? 'Basic shapes' : 'All shapes' }}
    </button>
  </div>
</mat-menu>
